<p-toast></p-toast>
<p-dialog
  header="Enter Role Management Passkey"
  [(visible)]="showPassKeyDialog"
  [modal]="true"
  [closable]="!(validatingPassKey || saving || adminSaving)"
  [dismissableMask]="!(validatingPassKey || saving || adminSaving)"
  [style]="{ width: '28rem' }"
  styleClass="kansei-dialog rm-passkey-dialog"
  (onHide)="closePassKeyDialog()">
  <div class="rm-passkey-content">
    <p class="rm-passkey-text">
      Enter the 6-character passkey to save role management changes.
    </p>
    <p-password
      [(ngModel)]="roleManagementPassKey"
      [feedback]="false"
      [toggleMask]="true"
      [maxlength]="6"
      [inputStyle]="{ width: '100%' }"
      styleClass="rm-passkey-input"
      placeholder="Enter passkey">
    </p-password>
    @if (passKeyError) {
      <p class="rm-passkey-error">{{ passKeyError }}</p>
    }
    <div class="rm-passkey-actions">
      <button type="button" class="rm-passkey-btn rm-passkey-btn-secondary" (click)="closePassKeyDialog()" [disabled]="validatingPassKey || saving || adminSaving">
        Cancel
      </button>
      <button type="button" class="rm-passkey-btn rm-passkey-btn-primary" (click)="confirmPassKeyAndSave()" [disabled]="validatingPassKey || saving || adminSaving">
        {{ validatingPassKey || saving || adminSaving ? 'Validating...' : 'Confirm & Save' }}
      </button>
    </div>
  </div>
</p-dialog>

<div class="rm-page">

  <!-- Header: title left, switch tabs right -->
  <div class="rm-header">
    <h1 class="rm-title">Permissions</h1>
    <div class="switch-tabs">
      <button
        type="button"
        [class.active]="activeView === 'project'"
        (click)="setView('project')">
        Project Level
      </button>
      <button
        type="button"
        [class.active]="activeView === 'application'"
        (click)="setView('application')">
        Application Level
      </button>
    </div>
  </div>

  <!-- Sub-bar: description left, save right -->
  <div class="rm-panel-hdr">
    <p class="rm-subtitle">Manage role access across pages and actions</p>
    @if (activeView === 'project') {
      <button class="rm-btn-save" type="button" [disabled]="loading || saving" (click)="savePermissions()">
        <i class="ri-save-line"></i>
        {{ saving ? 'Saving...' : 'Save Changes' }}
      </button>
    }
    @if (activeView === 'application') {
      <button class="rm-btn-save" type="button" [disabled]="adminLoading || adminSaving" (click)="saveAdminFeaturePermissions()">
        <i class="ri-save-line"></i>
        {{ adminSaving ? 'Saving...' : 'Save Changes' }}
      </button>
    }
  </div>

  <!-- ── PROJECT LEVEL VIEW ── -->
  @if (activeView === 'project') {

    @if (!loading && filteredPages.length === 0) {
      <div class="rm-empty">
        <i class="ri-shield-keyhole-line"></i>
        <p>No permissions configured yet.</p>
      </div>
    }

    @if (!loading && filteredPages.length > 0) {
      <div class="rm-cards">
        @for (page of filteredPages; track page.pageId) {
          <div class="rm-card">

            <div class="rm-card-hdr">
              <div class="rm-page-info">
                <span class="rm-page-name">{{ page.displayName }}</span>
                <span class="rm-page-key">{{ page.pageKey }}</span>
              </div>
              <div class="rm-role-cols">
                @for (role of roles; track role.roleId) {
                  <div class="rm-role-col">
                    <i class="ri-user-line"></i>
                    <span class="rm-role-name">{{ role.roleName }}</span>
                    <p-checkbox
                      [binary]="true"
                      [ngModel]="isPageRoleChecked(page, role.roleId)"
                      [indeterminate]="isPageRoleIndeterminate(page, role.roleId)"
                      (ngModelChange)="togglePageRolePermissions(page, role.roleId, $event)"
                      [disabled]="!page.permissions.length">
                    </p-checkbox>
                  </div>
                }
              </div>
            </div>

            <div class="rm-perm-list">
              @for (permission of page.permissions; track permission.permissionId) {
                <div class="rm-perm-row">
                  <span class="rm-perm-label">{{ permission.displayName }}</span>
                  <div class="rm-perm-checks">
                    @for (role of roles; track role.roleId) {
                      <div class="rm-perm-chk">
                        <p-checkbox
                          [binary]="true"
                          [ngModel]="isAllowed(permission.permissionId, role.roleId)"
                          (ngModelChange)="togglePermission(permission.permissionId, role.roleId, $event)">
                        </p-checkbox>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>

          </div>
        }
      </div>
    }

  }

  <!-- ── APPLICATION LEVEL VIEW ── -->
  @if (activeView === 'application') {

    @if (!adminLoading && adminSections.length === 0) {
      <div class="rm-empty">
        <i class="ri-shield-keyhole-line"></i>
        <p>No application features configured yet.</p>
      </div>
    }

    @if (!adminLoading && adminSections.length > 0) {
      <div class="rm-cards">
        @for (section of adminSections; track section.sectionId) {
          <div class="rm-card">

            <div class="af-card-hdr">
              <div class="rm-page-info">
                <span class="rm-page-name">{{ section.displayName }}</span>
                <span class="rm-page-key">{{ section.sectionKey }}</span>
              </div>
              <div class="af-role-groups">
                @for (role of systemRoles; track role.roleId) {
                  <div class="af-role-group">
                    <div class="af-role-group-name">
                      <i class="ri-user-line"></i>
                      <span>{{ role.roleName }}</span>
                    </div>
                    <div class="af-ut-cols">
                      @for (ut of userTypes; track ut.userTypeId) {
                        <div class="af-ut-col">
                          <span class="af-ut-name">{{ ut.name }}</span>
                          <p-checkbox
                            [binary]="true"
                            [ngModel]="isSectionRoleTypeChecked(section, role.roleId, ut.userTypeId)"
                            [indeterminate]="isSectionRoleTypeIndeterminate(section, role.roleId, ut.userTypeId)"
                            (ngModelChange)="toggleSectionRoleType(section, role.roleId, ut.userTypeId, $event)"
                            [disabled]="!section.features.length">
                          </p-checkbox>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>

            <div class="rm-perm-list">
              @for (feature of section.features; track feature.featureId) {
                <div class="rm-perm-row">
                  <span class="rm-perm-label">{{ feature.displayName }}</span>
                  <div class="af-role-groups">
                    @for (role of systemRoles; track role.roleId) {
                      <div class="af-role-group">
                        <div class="af-ut-cols">
                          @for (ut of userTypes; track ut.userTypeId) {
                            <div class="af-ut-col">
                              <p-checkbox
                                [binary]="true"
                                [ngModel]="isAdminFeatureAllowed(feature.featureId, role.roleId, ut.userTypeId)"
                                (ngModelChange)="toggleAdminFeature(feature.featureId, role.roleId, ut.userTypeId, $event)">
                              </p-checkbox>
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>

          </div>
        }
      </div>
    }

  }

</div>
